var chunkToChildrenMap = {
	"6281": [
		8080,
		6422,
		6323,
		7856,
		6419
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));